import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource, loadingData } from '@/commons/utils';
import moment from 'moment';
import Vue from 'vue';
export default class {
    constructor(endpoint, viewTitle) {
        this.state = {
            loading: false,
            all: {},
            selected: {}
        };
        this.getters = {
            selectedObject: state => {
                return state.selected
            }
        };
        this.actions = {
            getList({ commit }, param) {
                commit("setLoading", { loading: true });
                request_list(endpoint, data => {
                    commit('setList', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, param, this.state.authentication.token);
            },
            getDetail({ commit }, id) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        commit("setLoading", { loading: true });
                        request_detail(endpoint, item => {
                            commit('setDetail', item);
                            commit("setLoading", { loading: false });
                            resolve(item.data ? item.data : item);
                        }, Vue.http, id, this.state.authentication.token);
                    }, 100)
                  })
            },
            setDetail({ commit, getters }, { data, id, notify, ignore_compare = true}) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (id > 0) {
                            let updateObject = {};
                            if(!ignore_compare) {
                                const selectedObj = getters.selectedObject;
                                for (const prop in data) {
                                    if(prop.indexOf('_date') > 0 && moment(data[prop]).startOf('day').unix() != moment(selectedObj[prop]).startOf('day').unix()) {
                                        updateObject[prop] = data[prop];
                                    }
                                    else if(prop.indexOf('_date') <= 0 && data[prop] != selectedObj[prop]) {
                                        updateObject[prop] = data[prop];
                                    }
                                }
                                if(_.isEmpty(updateObject)) {
                                    sendErrorNotice('Không có thay đổi dữ liệu.')
                                    return;
                                }
                            }
                            else {
                                updateObject = data;
                            }                            
                            update_detail(endpoint, res => {
                                if (res.status === 202) {
                                    sendErrorNotice(res.reason)
                                }
                                else if (res.status !== 200) {
                                    sendErrorNotice(`Không thể cập nhật ${viewTitle}.`)
                                }
                                else {
                                    if(notify && notify != '') {
                                        sendSuccessNotice(notify);
                                    }
                                    else {
                                        sendSuccessNotice(`Cập nhật ${viewTitle} thành công.`)
                                    }
                                    resolve(res);
                                    refreshResource();
                                }
                            }, Vue.http, updateObject, id, this.state.authentication.token);
                        }
                        else {
                            delete data.id;
                            create_detail(endpoint, res => {
                                if (res.status === 202) {
                                    sendErrorNotice(res.reason)
                                }
                                if (res.status !== 200) {
                                    sendErrorNotice(`Không thể thêm mới ${viewTitle}.`);
                                }
                                else {
                                    sendSuccessNotice(`Thêm mới ${viewTitle} thành công.`);
                                    resolve(res);
                                    refreshResource();
                                }
                            }, Vue.http, data, this.state.authentication.token);
                        }
                    }, 100)
                })
            },
            removeDetail({ commit }, id) {
                commit("setLoading", { loading: true });
                remove_detail(endpoint, res => {
                    if (res.data.status === false) {
                        sendErrorNotice(`Không thể xóa ${viewTitle}.`);
                    }
                    else {
                        sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`);
                        refreshResource();
                    }
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            },
            removeBatch({ commit }, ids) {
                commit("setLoading", { loading: true });
                update_detail(`${endpoint}/delete`, res => {
                    if (res.data.status === false) {
                        sendErrorNotice(`Không thể xóa ${viewTitle}.`);
                    }
                    else {
                        sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`);
                        refreshResource();
                    }
                    commit("setLoading", { loading: false });
                }, Vue.http, {'ids': ids}, 0, this.state.authentication.token);
            }
        };
        this.mutations = {
            setList(state, data) {
                state.all = data;
            },
            setDetail(state, item) {
                state.selected = item.data ? item.data : item;
            },
            setLoading(state, { loading }) {
                loadingData(loading);
                state.loading = loading;
            }
        };
    }
}